import { useTranslation } from 'react-i18next';
import React, { ReactNode, useCallback, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { IconRcCopyLink, IconRcPageInModalLink } from '@/assets/components/pageinmodal';
import { openNewWindow, wrapModalPromise, WrapModalProps } from '@/utils';

import style from './index.module.scss';
import HelperTooltip from '../HelperTooltip';
import { CopyButton } from '../CopyButton';

type Props = {
  link: string;
  children: ReactNode;
  title: ReactNode;
};

const PageInModal = ({ link, children, title, hide }: WrapModalProps & Props) => {
  const { t } = useTranslation();

  const location = useLocation();
  const [_title, setTitle] = useState(title);
  const prePathName = useRef(location.pathname);

  const handleNewTabClick = useCallback(() => {
    hide();
    openNewWindow(link, '_blank');
  }, [link, hide]);

  useEffect(() => {
    // 当路由发生变化时，关闭当前弹窗
    if (location.pathname !== prePathName.current) {
      hide();
    }
  }, [hide, location.pathname]);

  return (
    <>
      <div className={style.header}>
        <div className={style.title}>{_title}</div>
        {link ? (
          <div className={style.btnContainer}>
            <HelperTooltip title={t('PageInModal.bb50k1')}>
              <IconRcPageInModalLink className={style.linkIcon} onClick={handleNewTabClick} />
            </HelperTooltip>
            <CopyButton
              className={style.copyBtn}
              text={`${window.location.protocol}//${window.location.host}${link}`}
              showMessage>
              <HelperTooltip title={t('PageInModal.1l2rmp1')}>
                <IconRcCopyLink className={style.linkIcon} />
              </HelperTooltip>
            </CopyButton>
          </div>
        ) : null}
      </div>
      <div className={style.main} id="detailModal">
        {React.isValidElement(children) &&
          React.cloneElement(children, { setTitle, inModal: true } as any)}
      </div>
    </>
  );
};

export const wrapPageModal = wrapModalPromise<Props>(PageInModal, {
  containerClassName: style.modalContainer,
});
